//@flow
import { createSelector } from 'reselect'
import { get } from 'lodash/fp'
import type { SaleFlowType } from './reducer'

export const getSaleFlow = createSelector(get('portal.saleFlow'), (saleFlow): SaleFlowType => saleFlow)
export const isFNAFlow = createSelector(get('portal.saleFlow'), (saleFlow): SaleFlowType => saleFlow === 'fna')
export const isQQFlow = createSelector(get('portal.saleFlow'), (saleFlow): SaleFlowType => saleFlow === 'quick-quote')
